<template>
	<div>
		<p
			class="text-smaller pb-4"
		>{{$t('Kérjük adja meg a regisztráció alkalmával megadott e-mail címét, és elküldjük Önnek a jelszóváltoztatáshoz szükséges információkat.')}}</p>

		<form @submit.prevent.stop="submit()">
			<div class="form-group form-group--with-icon pb-4">
                <label for="email" class="d-none">{{$t('E-mail cím')}}</label>
				<input v-model="$v.email.$model" v-input-class type="email" id="email" class="input" :placeholder="$t('E-mail cím')" />
				<span class="input__icon">
					<img src="@/assets/icons/email.svg" alt="Email" />
				</span>
                <div class="input__error" v-if="$v.email.$error">
					<span>
						<img src="@/assets/icons/warning.svg" alt="Hiba" />
					</span>
					<span v-if="!$v.email.required">{{$t('A mező kitöltése kötelező!')}}</span>
					<span v-else-if="!$v.email.email">{{$t('Hibás e-mail cím!')}}</span>
				</div>
			</div>

			<div class="pb-4">
				<button type="submit" :disabled="$v.$invalid" class="button w-100">{{$t('Küldés')}}</button>
			</div>
		</form>

		<div class="pb-4 text-smaller color-grey3">
			<router-link class="link-dark" :to="{name: 'login'}">{{ $t('Vissza a bejelentkezéshez') }}</router-link>
		</div>
	</div>
</template>

<script>
import { requestPasswordResetUsingPOST } from "@/api";
import {
	required,
	email,
} from "vuelidate/lib/validators";
export default {
	name: "ForgottenPassword",
	data() {
		return {
			email: null,
		};
	},
    validations: {
		email: {
			required,
			email,
		}
	},
	methods: {
		submit: function () {
			requestPasswordResetUsingPOST({ mail: this.email, $config: {headers: { 'Content-Type': 'text/plain' }} })
				.then((response) => {
					if (response.status === 200) {
						this.$swal({
							title: this.$t("Elfelejtett jelszó"),
							text: this.$t("A regisztrációkor megadott e-mail címére egy levelet küldtünk a jelszó cseréhez szükséges hivatkozással."),
							imageUrl: window.swalSuccess,
						}).then(() => {
                            this.$router.push({ name: "login" });
                        });
					} else if (response.status === 404) {
						this.$swal({
							title: this.$t("Elfelejtett jelszó"),
							text: this.$t("A megadott e-mail címmel nem találtunk regisztrációt."),
							imageUrl: window.swalError,
						});
					}
				})
				.catch((err) => {
                    this.$swal({
                            title: this.$t("Elfelejtett jelszó"),
                            text: err.errorMessage,
                            imageUrl: window.swalError,
                        });
					console.warn(err);
				});
		},
	},
};
</script>